module.exports = __webpack_public_path__ + "static/quaals_feather_token_tree-0cacb0139a35e67a5154cc1aebc0279a.jpeg";